@if (categoryForm()) {
<form [formGroup]="categoryForm()">
    <div class="form-group row mb-3">
        <label class="col-md-4 col-form-label">Slug</label>
        <div class="col-md-8">
            @if (mode() === formMode.CREATE) {
                <input type="text" class="form-control text-uppercase" formControlName="slug"
                    placeholder="EJ. TRANSFER"
                    (blur)="categoryForm().get('slug')?.setValue(($any($event.target).value || '').toUpperCase())">
                @if (categoryForm().get('slug')?.errors?.['required'] && categoryForm().get('slug')?.touched) {
                    <div><small class="text-danger">El slug es requerido.</small></div>
                }
                @if (categoryForm().get('slug')?.errors?.['pattern'] && categoryForm().get('slug')?.touched) {
                    <div><small class="text-danger">Use UPPER_SNAKE (letras, números y _).</small></div>
                }
            } @else {
                <div class="form-group mb-0">
                    <strong><code>{{ categoryForm().get('slug')?.value }}</code></strong>
                    <div class="form-text small">El identificador slug no se puede cambiar si hay procesos usándolo.</div>
                </div>
            }
        </div>
    </div>

    <div class="form-group row mb-3">
        <label class="col-md-4 col-form-label">Nombre</label>
        <div class="col-md-8">
            <input type="text" class="form-control" formControlName="name" placeholder="Ej. Transferencia">
            @if (categoryForm().get('name')?.errors?.['required'] && categoryForm().get('name')?.touched) {
                <div><small class="text-danger">El nombre es requerido.</small></div>
            }
        </div>
    </div>

    <div class="form-group row mb-3">
        <label class="col-md-4 col-form-label">Abreviatura</label>
        <div class="col-md-8">
            <input type="text" class="form-control text-uppercase" formControlName="abbr" placeholder="Ej. TRF">
        </div>
    </div>

    <div class="form-group row mb-3">
        <label class="col-md-4 col-form-label">Icono (FontAwesome)</label>
        <div class="col-md-8">
            <div class="input-group">
                <span class="input-group-text">
                    <i [class]="categoryForm().get('icon')?.value || 'fas fa-folder'"></i>
                </span>
                <input type="text" class="form-control" formControlName="icon" placeholder="Ej. fa fa-exchange">
            </div>
            <div class="form-text small">Clase CSS de FontAwesome</div>
        </div>
    </div>

    <div class="form-group row mb-3">
        <label class="col-md-4 col-form-label">Activa</label>
        <div class="col-md-8 d-flex align-items-center">
            <div class="form-check form-switch mb-0">
                <input class="form-check-input" type="checkbox" formControlName="isActive" id="catIsActive">
                <label class="form-check-label" for="catIsActive">Visible en selectores de proceso</label>
            </div>
        </div>
    </div>
</form>
}
